import React from 'react';
import PropTypes from 'prop-types';
import { Sticky } from '@bd/bdcore-utilities';

import Filters from '../../components/Filters';

class FilterBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: null,
    };

    this.closeMenu = this.closeMenu.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.addMenuToggleRef = this.addMenuToggleRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside);

    (this.toggleRefs || []).forEach(node => {
      node.removeEventListener('click', this.openMenu);
    });
  }

  addMenuToggleRef(node) {
    if (!this.toggleRefs) {
      this.toggleRefs = [];
    }

    if (node) {
      node.addEventListener('click', this.openMenu);
      this.toggleRefs.push(node);
    }
  }

  openMenu(e) {
    e.preventDefault();

    const menu = e.target.dataset.menu;
    if (!menu) {
      return;
    }

    this.setState({
      menu: this.state.menu === menu ? null : menu,
    });
  }

  closeMenu(e) {
    e.preventDefault();

    this.setState({
      menu: null,
    });
  }

  handleClickOutside(event) {
    if (this.toggleRefs && !this.toggleRefs.find(ref => ref && ref.contains(event.target))) {
      this.closeMenu(event);
    }
  }

  render() {
    const {
      type, filterOptions, itemCount, showingCount,
      name, setSortBy, sortOptions, style,
    } = this.props;
    return (
      <Sticky style={style || { zIndex: 100 }}>
        <div className="filter-bar-sticky">
          <div className="filter-bar">
            <div className="filter-bar-btn" data-menu="filters" ref={this.addMenuToggleRef}>
              <img src="/images/icon-filter-red.svg" alt="Filter Icon" /> Filter
            </div>
            <div className="filter-bar-btn sort" data-menu="sort" ref={this.addMenuToggleRef}>
              <img src="/images/icon-sort-red.svg" alt="Sort Icon" /> Sort
              {
                this.state.menu === 'sort' &&
                <ul className="dropdown">
                  { sortOptions.map(option => (
                    <li key={option.field}>
                      <a
                        href=""
                        onClick={e => {
                          e.preventDefault();
                          setSortBy(option);
                          this.closeMenu(e);
                        }}
                      >
                        {option.title}
                      </a>
                    </li>
                  ))}
                </ul>
              }
            </div>
            <div className="filter-bar-btn map">
              <img src="/images/icon-map-pin-blue.svg" alt="Map Pin" /> Map View
            </div>
            <div className="filter-bar-count">
              Showing {' '}
              <strong>{showingCount}</strong>
              {' '} of {' '}
              <strong>{itemCount}</strong>
              {' '}{ name }
            </div>
          </div>
          {
            this.state.menu === 'filters' &&
            <div ref={this.addMenuToggleRef}>
              <div className="col-12 filters">
                <Filters
                  type={type}
                  filterOptions={filterOptions}
                />
                <a href="" className="filter-close" onClick={this.closeMenu}>
                  <img src="/images/icon-close-charcoal.svg" alt="filter close button" />
                </a>
              </div>
            </div>
          }
        </div>
      </Sticky>
    );
  }
}

FilterBar.propTypes = {
  type: PropTypes.string.isRequired,
  itemCount: PropTypes.number,
  showingCount: PropTypes.number,
  name: PropTypes.string,
  setSortBy: PropTypes.func,
  filterOptions: PropTypes.arrayOf(PropTypes.object),
  sortOptions: PropTypes.arrayOf(PropTypes.object),
  style: PropTypes.object,
};
FilterBar.defaultProps = {
  itemCount: 0,
  showingCount: 0,
  filterOptions: [],
  name: 'Items',
  setSortBy: () => {},
  sortOptions: [],
  style: undefined,
};

export default FilterBar;



// WEBPACK FOOTER //
// ./src/pages/FilterBar/index.js